export default __webpack_public_path__ + "static/media/CoffeeShop.0bc87a8a.jpg";